import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-awaiting-quotes',
    templateUrl: './awaiting-quotes.component.html',
    styleUrls: ['./awaiting-quotes.component.css'],
    standalone: false
})
export class AwaitingQuotesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
